"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const isRevolving = (name) => name.toLowerCase().includes('revolving');
exports.default = isRevolving;
